export function setUser(state,data){
    state.user = data
}

export function setToken (state,dados) {
    state.token = dados
}

export function setLogin (state,data) {
    state.token = data.token;
    state.user = data.user;     
    state.enums = data.enums;  
    state.enumsLV = data.enumsLinhaVazia;
    state.enumsObjs = data.enumsObjs;
    state.menu = data.menuWeb;
    state.empresaDest = data.empresaDest;
}

export function clearLogin(state) {
    state.token = null;
    state.user = null;
}

export function setErrorLogin(state,value){
    state.errorLogin=value;
}

export function setTitleScreen(state,title){
    state.titleScreen = title;
}

export function setShowLoading(state,showLoading){
    state.showLoading = showLoading;
}

export function tokenPainel (state, tokenPainel) {
    return state.tokenPainel = tokenPainel
}
